import http from '../../utils/fetch';
export default {
    baseurl: '/api/swyl/v1/dingd/bsc',


    //创建新订单
    createCgOrder(query) {
        return http.post(this.baseurl + '/OrderCg/insert', query);
    },

    //查询供应商商品占比
    selectProSupplier(entity){
        return http({
            url: 'api/swyl/v1/dingdmain/selectProSupplier',
            method: 'post',
            params: entity
        });
        // return http.post('api/swyl/v1/dingdmain/selectProSupplier', entity);
    },
    //创建新订单list
    createCgOrderlist(query) {
        return http.post(this.baseurl + '/OrderCg/insertlist', query);
    },
    //OEM订单生成采购订单审批通过方法
    insertOEMlist(query) {
        return http.post(this.baseurl + '/OrderCg/insertOEMlist', query);
    },

    //驳回采购订单重新提交list
    renewOrderCglist(query) {
        return http.post(this.baseurl + '/OrderCg/renewOrderCglist', query);
    },

    //查看分页列表
    selectPage(query) {
        return http({
            url: this.baseurl + '/OrderCg/selectPage',
            method: 'post',
            params: query
        });
    },
    //根据订单id查看采购订单详情
    selectById(query) {
        return http({
            url: this.baseurl+'/OrderCg/selectById?id='+query,
            method: 'post',
            params: query
        });
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
    },


    //根据订单id查看采购订单详情list
    caigouselectById(query) {
        return http({
            url: this.baseurl+'/OrderCg/caigouselectById?id='+query,
            method: 'post',
            params: query
        });
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
    },
    selectPageForFinance(entity) {
        return http({
            url: '/api/swyl/v1/order/viewOrderCaiwubb/selectPage',
            method: 'post',
            params: entity
        });
    },
    selectPageForFinance2(entity) {
        return http({
            url: '/api/swyl/v1/demo/viewOrderCaiwubbTwo/selectPage',
            method: 'post',
            params: entity
        });
    },

    //审批使用的查看采购订单详情list
    appselectById(query) {
        return http({
            url: this.baseurl+'/OrderCg/appselectById?id='+query,
            method: 'post',
            params: query
        });
    },

    //审批通过采购订单接口
    approveSuccess(query){
        return http({
            url: this.baseurl + '/OrderCg/approveOrderCgSucess',
            method: 'post',
            data: query
        });
    },
    //审批驳回采购订单接口
    approveFail(query) {
        return http({
            url: this.baseurl + '/OrderCg/approveOrderCgFail',
            method: 'post',
            data: query
        });
    },

    //审批通过采购订单接口list
    approveSuccesslist(query) {
        return http({
            url: this.baseurl + '/OrderCg/approveOrderCgSucesslist',
            method: 'post',
            data: query
        });
    },

    //审批通过采购订单接口list
    approveOrderCgShSucess(query) {
        return http({
            url: this.baseurl + '/OrderCg/approveOrderCgShSucess',
            method: 'post',
            data: query
        });
    },

    //审批驳回采购订单接口list
    approveFaillist(query) {
        return http({
            url: this.baseurl + '/OrderCg/approveOrderCgFaillist',
            method: 'post',
            data: query
        });
    },


    //筛选可审批的
    shuaixuanInstid(query) {
        return http.post(this.baseurl + '/OrderCg/shuaixuanInstid', query);
    },

    //根据流程主键查看采购订单详情
    selectListByInstid(query) {
        /*return http({
            url: this.baseurl+'/OrderCg/selectListById',
            method: 'post',
            params: query
        });*/
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
        return http.post(this.baseurl + '/OrderCg/selectListById', query);
    },
    //上海采购订单对应销售订单提交SAP成功时间如果是2021年3月1日之前创建的继续走原来的发货接口
    checkOrderCg(query) {
        /*return http({
            url: this.baseurl+'/OrderCg/selectListById',
            method: 'post',
            params: query
        });*/
        return http.post(this.baseurl + '/OrderCg/checkOrderCg', query);
    },

     //根据流程主键查看采购订单详情
     selectOrderListByInstid(query) {
        /*return http({
            url: this.baseurl+'/OrderCg/selectListById',
            method: 'post',
            params: query
        });*/
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
        return http.post(this.baseurl + '/OrderCg/selectOrderListById', query);
    },

    //根据流程主键查看采购订单详情
    selectByInstid(query) {
        return http({
            url: this.baseurl+'/OrderCg/selectByInstid?instid='+query,
            method: 'post',
            params: query
        });
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
    },
    //根据流程主键查看采购订单详情
    selectByTaskidInstid(query) {
        return http({
            url: this.baseurl+'/OrderCg/selectByInstid',
            method: 'post',
            params: query
        });
        // return http.post(this.baseurl + '/OrderCg/selectById?id=' + query)
    },
    //驳回采购订单重新提交
    renewOrderCg(query) {
        return http.post(this.baseurl + '/OrderCg/renewOrderCg', query);
    },
    //更新采购订单的发货数据状态
    updateWaybillId(query) {
        return http.post(this.baseurl + '/OrderCg/updateWaybillId', query);
    },
    //更新采购订单的发货数据状态
    updateWaybillIdSh(query) {
        return http.post(this.baseurl + '/OrderCg/updateWaybillIdSh', query);
    },
    //维护发票信息
    saveInvoicePage(query) {
        return http.post(this.baseurl + '/OrderCg/saveInvoicePage', query);
    },
	//采购订单发货
	fahuo(query) {
		return http.post(this.baseurl + '/OrderCg/fahuo', query);
	},
    //采购批量订单发货
    fahuoBatch(query) {
        return http.post(this.baseurl + '/OrderCg/fahuoBatch', query);
    },
    //更新采购订单收货信息
    updateCount(query) {
        return http.post(this.baseurl + '/OrderCg/updateCount', query);
    },
    //更新采购订单收货信息
    updateCountList(query) {
        return http.post(this.baseurl + '/OrderCg/updateCountList', query);
    },
    //9390卖6200采购订单收货-整单
    updateCountByHk(query) {
        return http.post(this.baseurl + '/OrderCg/updateCountByHk', query);
    },
    //6200卖美国荷兰采购订单收货-整单
    updateCountBySales(query) {
        return http.post(this.baseurl + '/OrderCg/updateCountBySales', query);
    },
    //获取付款总额
    selectBySCode(query) {
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/selectBySCode?supperCode='+query,
            method: 'post'
        });
    },
    //查询待付款采购订单列表
    selectOrderCgFuKList(query) {
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/selectOrderCgFuKList?supperCode='+query,
            method: 'post'
        });
    },
    //获取付款总额
    selectSupLists(query) {
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/selectSupLists',method: 'post'});
    },
    //采购订单供应商付款
    saveCgFk(query) {
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/saveCgFk',
            method: 'post',
            data: query
        });
    },
    //获取所勾选的采购订单付款列表
    getCgPaymentList(query){
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/getCgPaymentList',
            method: 'post',
            data: query
        });
    },
    jiansuoFukuan(query){
        return http({
            url: this.baseurl + '/OrderCgPayRhythm/jiansuoFukuan',
            method: 'post',
            data: query
        });
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },
	//查询采购备货单
	getBeihuoList(query){
		return http({
		    url: '/api/swyl/v1/dingd/bsc/OrderCg/getBeihuoList',
		    method: 'post',
            params: query
		});
	},
	//作废采购订单
	deleteCgOrder(id,deleteReason){
		return http({
		    url: '/api/swyl/v1/dingd/bsc/OrderCg/deleteCgOrder',
		    method: 'post',
			params:{id,deleteReason}
		});
    },
    //撤回采购订单
    chehuiCgOrder(id){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/chehuiCgOrder',
            method: 'post',
            params:{id}
        });
    },
    //撤回上海采购订单
    chehuiCgOrderSh(query){
        /*return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/chehuiCgOrderSh',
            method: 'post',
            params:{id}
        });*/
        return http.post(this.baseurl + '/OrderCg/chehuiCgOrderSh', query);
    },
    //采购订单付款提交
    isPay(id){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/updateIsPayById',
            method: 'post',
            params:{id}
        });
    },
    //采购订单付款提交
    isPaySh(query){
        /*return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/updateIsPayShById',
            method: 'post',
            params:{id}
        });*/
        return http.post(this.baseurl + '/OrderCg/updateIsPayShById', query);
    },
    //修改待审批的采购订单
    changeCgOrder(query){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/changeCgOrder',
            method: 'post',
            params: query
        });
    },
    //背靠背付款报表分页
    selectBackPage(v){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/selectBackPage',
            method: 'post',
            params:v
        });
    },

    //查看发票信息列表分页
    selectFp(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderCgInvoice/getInvoicePage',
            method: 'post',
            params: query
        });
    },

    //根据采购编号查询发票信息(可输入多个订单号,后台拆分检索)，后台接收字符串进行拆分
    selectOrderAndMoney(codes) {
        return http({
            url: this.baseurl + '/OrderCg/selectOrderAndMoneya',
            method: 'post',
            params: {codes}
        });
    },
    //打印条形码
    createCgBarCode(q){
        ///api/swyl/v1/demo/bscAccompanyingInstruction/createCgBarCode
        return http({
            responseType: 'arraybuffer',
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/createCgBarCode',
            method: 'post',
            params: q
        });
    },


    //根据订单号查询发票信息
    selectInvoiceNoXinxiByCodeCg(code) {
        return http({
            url: this.baseurl + '/OrderCg/selectInvoiceXinxiByOrderCode',
            method: 'post',
            params: {code}
        });
    },
    //查看订单列表分页(支持检索订单号)
    selectOrder(query) {
        return http({
            url: this.baseurl + '/OrderCg/getOrderPage',
            method: 'post',
            params: query
        });
    },

    //查看发票列表分页(支持检索发票号)
    selectInvoice(query) {
        return http({
            url:  '/api/swyl/v1/demo/bscOrderCgInvoice/getInvoicePage',
            method: 'post',
            params: query
        });
    },
    //根据发票号查询订单信息(检索)
    selectFph(invoicenos) {
        return http({
            url: this.baseurl + '/OrderCg/selectFphao',
            method: 'post',
            params: {invoicenos}
        });
    },
    //验证是否存在发票号，不存在则添加(用于添加发票号使用,传对象)
    insertFpha(query) {
        return http({
            url: this.baseurl + '/OrderCg/insertFpha',
            method: 'post',
            params: query
        });
    },
    //保存发票信息 关联使用， 后台返回是否关联成功
    saveInvoiceAndOrder(query) {
        return http({
            url: this.baseurl + '/OrderCg/saveInvoiceList',
            method: 'post',
            data: query
        });
    },
    //前台一个对象，对象里面两个对象集合
    //后台返回两个集合订单集合、发票集合
    saveInvoicejilu(query) {
        return http({
            url: this.baseurl + '/OrderCg/selectInvoiceAndOrderRelation',
            method: 'post',
            data: query
        });
    },
    //根据订单号关联发票号，传后台一个订单号和发票号的字符串，每个发票号用；隔开
    //后台返回是否成功
    guanlianfph(invoicenos,code) {
        return http({
            url: this.baseurl + '/OrderCg/guanlianFphao',
            method: 'post',
            params: {invoicenos,code}
        });
    },
    //根据发票号关联订单号，传后台一个发票号和订单号的字符串，每个订单号用；隔开
    //后台返回是否成功
    guanlianddh(invoiceno,codes) {
        return http({
            url: this.baseurl + '/OrderCg/guanlianDdhao',
            method: 'post',
            params: {invoiceno,codes}
        });
    },
    //解除关联订单号和发票号，前台传给后台一个发票号一个订单号
    // jichuFphaoAndDdhao(invoiceno,code) {
    //     return http({
    //         url: this.baseurl + '/OrderCg/jiechuDdhaoAndFphao',
    //         method: 'post',
    //         data: {invoiceno,code}
    //     });
    // },
    //通过订单号解除发票号信息，前台传订单号和发票号以；分割的字符串
    jiechuFphaoByDdhao(invoicenos,code) {
        return http({
            url: this.baseurl + '/OrderCg/jiechuFphaoAndDdhao',
            method: 'post',
            params: {invoicenos,code}
        });
    },
    //通过发票号解除订单号，前台传订单号以；分割的字符串和发票号
    jichuDdhaoByFphao(invoiceno,codes) {
        return http({
            url: this.baseurl + '/OrderCg/jiechuDdhaoAndFphao',
            method: 'post',
            params: {invoiceno,codes}
        });
    },
    //根据订单集合查询订单和发票信息
    insertFph(query) {
        return http({
            url: this.baseurl + '/OrderCg/selectOrderAndMoneyaByXinxi',
            method: 'post',
            params: query
        });
    },
    //修改发票信息，传对象，发票号不可修改
    xiugaiFpxinxi(query) {
        return http({
            url:  '/api/swyl/v1/demo/bscOrderCgInvoice/xiugaiInvoiceXinxi',
            method: 'post',
            params: query
        });
    },
    //根据发票栏信息更新订单号信息
    selectOrderByInvoiceNoXinxi(query) {
        return http({
            url: this.baseurl + '/OrderCg/selectOrderByInvoiceo',
            method: 'post',
            params: query
        });
    },
    //根据订单栏信息更新发票号信息
    selectInvoiceNoByOrderXinxi(query) {
        return http({
            url: this.baseurl + '/OrderCg/selectInvoiceByOrder',
            method: 'post',
            params: query
        });
    },
    //通过发票号删除发票信息，传发票号
    deletefph(invoicenos) {
        return http({
            url: this.baseurl + '/OrderCg/deletefph',
            method: 'post',
            params: {invoicenos}
        });
    },
    //更改多个附件上传状态
    updateFjStatus(sapCodes) {
        return http.post('/api/swyl/v1/dingd/bsc/OrderCg/updateFjStatus',sapCodes);
    },

    //审批通过采购订单接口
    approveTcSuccess(query){
        return http({
            url: this.baseurl + '/OrderCg/approveTcCgSuccess',
            method: 'post',
            data: query
        });
    },

    // PR采购单-绑定list
    selectPagePR(query) {
        return http({
            url: '/api/swyl/v1/demo/sapPrDemand/selectPage',
            method: 'post',
            params:query
        });
    },
    //根据订单id查看采购订单详情
    selectById_PR(query) {
        return http({
            url: '/api/swyl/v1/demo/sapPrDemand/selectById?id='+query,
            method: 'post',
            params: query
        });
    },
    //根据供应商编码和物料编码获取产品采购特价信息
    getPriceBySupplier(q){
        return http({
            url: '/api/swyl/v1/xiangmu/proPriceInquiry/getPriceBySupplier',
            method: 'post',
            params: q
        });
    },
    //质量校验
    checkQuality(data) {
        return http.post('/api/swyl/v1/test/ViewUserSupplierController/checkQuality',data);
    },

    //新增采购默认值
    saveCgDefault(q){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/saveCgDefault',
            method: 'post',
            params: q
        });
    },
    //获取默认值
    getDefaultCg(q){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/getDefaultCg',
            method: 'post',
            params: q
        });
    },
    //新增采购默认值
    checkCgPayment(q){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/checkCgPayment',
            method: 'post',
            params: q
        });
    },
}
